/**
 * Enum Theo dõi
 * tvhien 01.08.2022
 */
export default {
  All: -1,
  Follow: 1,
  Unfollow: 0,
};
